import { Deserializable } from '../protocols/deserializable';

export abstract class BaseRemittanceContributionSummary implements Deserializable {
  public totalContributionCount!: number;
  public totalEntryCount!: number;
  public totalAmount!: number;
  public entrySummaries!: EntrySummary[];

  onDeserialize(): void {
    if (this.entrySummaries && Array.isArray(this.entrySummaries)) {
      this.entrySummaries.sort((a, b) => a.entryTypeId - b.entryTypeId);
    }
  }
}

export class EntrySummary implements Deserializable {
  public entryTypeId!: number;
  public entryType!: string;
  public entryCount!: number;
  public amount!: number;

  onDeserialize() {}
}
